import React, { Component } from 'react';
import { Input, Modal, Radio, message } from 'antd';
import styles from './modal.module.css';
import { products, products2, standardsTypes, rodrailsTypes, winType1, winType2, singlePulley1, singlePulley, getInstall, sizeWidth2, sizeHeight2 } from '../../../utils/remark';

const newData = {
  id: 0,
  order: 0,
  room: '',
  width: '0',
  width_remark: '满盒尺寸',
  height: '0',
  height_remark: '盒顶到地面',
  prop1: '直轨',//产品类型
  prop2: '顶装',//安装方式
  prop3: '无',//窗帘盒
  prop4: '||',//窗帘盒尺寸 |单层滑轮数|是否含滑臂
  prop5: '单层',//层数 //成品帘拉绳
  prop6: '双开|平分双开|',//开合方式
  prop7: '普通窗|否|',//窗户类型|是否内开窗|内开窗距离
  prop8: '',
  prop9: '混凝土',//安装墙面
  prop10: '否',//是否超高
  prop11: '否',//是否拆旧
  prop12: '',//安装面宽度
  prop13: '',//罗马杆装饰头
  prop14: '无',//石膏线
  prop15: '',//石膏线尺寸  //（已安装）活动走珠间隙
  prop16: '无',//有无窗幔|尺寸|包边情况
  prop17: '手动|||',//驱动方式|有无电源|电源方向|玻璃满墙
  prop18: '',
  prop19: '',//离地尺寸
  prop20: '',//是否需要做飘窗垫|飘窗垫厚度
  prop21: '',//窗台是否凸出|尺寸   //有无把手凸出|尺寸  //是否需要截断发货
  pic: [],
  vod: [],
  state: '',
  remark: '无',
  plasterLine: '无',
}

class RelateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      currentData: { ...newData },
      width_remark: '',
      height_remark: '',
      index: 0,
    }
  }
  render() {
    const { visible, currentData, width_remark, height_remark, } = this.state;
    let currentWidth = ['自定义'];
    let currentHeight = ['自定义'];
    if (currentData.prop7.split('|')[0] && currentData.prop1 && currentData.prop2) {
      currentWidth = sizeWidth2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0]);
      currentHeight = sizeHeight2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])
    }
    return (
      <Modal
        title='产品选择'
        visible={visible}
        onCancel={this.onCancel}
        onOk={this.onOk}
        width={700}
        okText='确定'
        cancelText='取消'
      >


        {/* 建议产品： */}
        <div className='row-l vertical-lt margin-b10'>
          <div className='w80'>建议产品：</div>
          <Radio.Group value={currentData.prop1} onChange={this.changeProps.bind(this, 'prop1')} className='w550'>
            {
              products2.map((item, index) => {
                return (
                  <Radio value={item} key={index}>{item}</Radio>
                );
              })
            }
          </Radio.Group>
        </div>
        {/* 安装方式： */}
        <div className='row-l vertical-lt margin-b10'>
          <div className='w80'>安装方式：</div>
          <Radio.Group value={currentData.prop2.split('|')[0]} onChange={this.changeProps.bind(this, 'prop2')} className='w500'>
            {
              getInstall(currentData.prop1).map((item, index) => {
                return (
                  <Radio value={item} key={index}>{item}</Radio>
                );
              })
            }

          </Radio.Group>
        </div>
        {/* 驱动方式 */}
        <div className='row-l margin-b10'>
          <div className='w80'>驱动方式：</div>
          <Radio.Group value={currentData.prop17.split('|')[0]} onChange={this.changeProps.bind(this, 'prop17')}>
            <Radio value='电动'>电动</Radio>
            <Radio value='手动'>手动</Radio>
          </Radio.Group>
        </div>
        {/* 窗户类型 */}
        <div className='row-l vertical-lt margin-b10'>
          <div className='w80 margin-b20'>窗户类型：</div>
          <div className='col-t vertical-lt'>
            <Radio.Group value={currentData.prop7.split('|')[0]} onChange={this.changeWin} className='w550'>
              {
                winType1.map((item, index) => {
                  return (
                    <Radio value={item} key={index}>{item}</Radio>
                  );
                })
              }
            </Radio.Group>
            <Radio.Group value={currentData.prop7.split('|')[0]} onChange={this.changeWin} className='w550'>
              {
                winType2.map((item, index) => {
                  return (
                    <Radio value={item} key={index}>{item}</Radio>
                  );
                })
              }
            </Radio.Group>
          </div>
        </div>
        <div className='w80'>宽度说明：</div>
        <div className='row-w margin-b10'>
          {
            currentWidth.map((item, index) => {
              return (
                <div
                  onClick={this.changeProps.bind(this, 'width_remark', item)}
                  className={`${styles['menu']} ${styles[currentData.width_remark === item ? 'select2' : 'select1']} cursor-pointer`}
                  key={index}
                >{item}</div>
              );
            })
          }
          {currentData.width_remark === '自定义' &&
            <Input value={width_remark} onChange={this.changeInput.bind(this, 'width')} placeholder='自定义宽度说明' />
          }
        </div>
        <div className='w80'>高度说明：</div>
        <div className='row-w margin-b10'>
          {
            currentHeight.map((item, index) => {
              return (
                <div
                  onClick={this.changeProps.bind(this, 'height_remark', item)}
                  className={`${styles['menu']} ${styles[currentData.height_remark === item ? 'select2' : 'select1']} cursor-pointer`}
                  key={index}
                >{item}</div>
              );
            })
          }
          {currentData.height_remark === '自定义' &&
            <Input value={height_remark} onChange={this.changeInput.bind(this, 'height')} placeholder='自定义高度说明' />
          }
        </div>
        {
          standardsTypes.includes(currentData.prop1) &&
          <div className='row-l'>
            <div>拉绳：</div>
            <Radio.Group value={currentData.prop5} onChange={this.changeProps.bind(this, 'prop5')}>
              <Radio value='左'>左</Radio>
              <Radio value='右'>右</Radio>
            </Radio.Group>
          </div>
        }
        {
          ['罗马杆', '宜家罗马杆',].includes(currentData.prop1) && currentData.prop2.indexOf('侧装') > -1 &&
          <div className='row-l'>
            <div>旋转支架：</div>
            <Radio.Group value={currentData.prop2.split('|')[1]} onChange={this.changeHolder}>
              <Radio value='是'>是</Radio>
              <Radio value='否'>否</Radio>
            </Radio.Group>
          </div>
        }
      </Modal>
    );
  }
  //窗户类型
  changeWin = (e) => {
    let currentData = { ...this.state.currentData };
    let prop7 = currentData.prop7.split('|');
    prop7[0] = e.target.value;
    currentData.prop7 = prop7.join('|');
    if (sizeWidth2(currentData.prop1, currentData.prop2, e.target.value)[0]) {
      currentData.width_remark = sizeWidth2(currentData.prop1, currentData.prop2, e.target.value)[0];
    } else {
      currentData.width_remark = '自定义';
    }
    if (sizeHeight2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0]) {
      currentData.height_remark = sizeHeight2(currentData.prop1, currentData.prop2, e.target.value)[0];
    } else {
      currentData.height_remark = '自定义';
    }
    this.setState({
      currentData,
      width_remark: '', height_remark: '',
    });
  }

  changeHolder = (e) => {
    let currentData = { ...this.state.currentData };
    let prop2 = currentData.prop2.split('|');
    prop2[1] = e.target.value;
    currentData.prop2 = prop2.join('|')
    this.setState({
      currentData
    });
  }
  changeProps = (props, e) => {
    let currentData = { ...this.state.currentData };
    let width_remark = this.state.width_remark;
    let height_remark = this.state.height_remark;
    if (props === 'width_remark' || props === 'height_remark') {
      currentData[props] = e;
    } else if (props === 'prop5') {
      currentData[props] = e.target.value;
    } else if (props === 'prop1') {
      currentData[props] = e.target.value;
      currentData.prop2 = getInstall(e.target.value)[0] ? getInstall(e.target.value)[0] : '';
      if (e.target.value === '罗马杆') {
        currentData.prop2 = getInstall(e.target.value)[1] ? getInstall(e.target.value)[1] : '';
      }

      let prop4 = currentData.prop4.split('|');
      prop4[1] = '';
      prop4[2] = '';
      currentData.prop4 = prop4.join('|');
      currentData.prop5 = standardsTypes.includes(e.target.value) ? '右' : '单层';
      currentData.prop13 = '';
      currentData.prop16 = '无||';
      if (!['罗马杆', '宜家罗马杆', '梦幻帘'].concat(rodrailsTypes).includes(e.target.value)) {
        currentData.prop19 = ''
      }
      if (e.target.value === '梦幻帘') {
        currentData.prop21 = '否|';
      } else if (standardsTypes.includes(e.target.value)) {
        currentData.prop21 = '无|';
      } else if (['罗马杆', '宜家罗马杆',].includes(e.target.value)) {
        currentData.prop21 = '';
        currentData.prop13 = '两边装饰头';
      }
      if (sizeWidth2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0]) {
        currentData.width_remark = sizeWidth2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0];
      } else {
        currentData.width_remark = '自定义';
      }
      if (sizeHeight2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0]) {
        currentData.height_remark = sizeHeight2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0];
      } else {
        currentData.height_remark = '自定义';
      }
      if (e.target.value === '磁控百叶') {
        currentData.prop5 = '';
        currentData.prop12 = '';
        currentData.prop15 = '';
        currentData.prop16 = '';
        currentData.prop18 = ''
        currentData.prop19 = ''
        currentData.prop20 = ''
        currentData.prop21 = ''
      }
      width_remark = '';
      height_remark = '';
    } else if (props === 'prop2') {
      // prop2
      currentData[props] = e.target.value;
      let prop4 = currentData.prop4.split('|');
      prop4[1] = '';
      prop4[2] = '';
      currentData.prop4 = prop4.join('|');
      currentData.prop13 = '';
      if (e.target.value === '已安装') {
        currentData.prop15 = '';
      } else {
        if (['罗马杆', '宜家罗马杆',].includes(currentData.prop1)) {
          currentData.prop13 = '两边装饰头';
          currentData.prop21 = '';
          if (e.target.value === '侧装') {
            currentData.prop2 = '侧装|否';
          }
        }
      }
      if (sizeWidth2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0]) {
        currentData.width_remark = sizeWidth2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0];
      } else {
        currentData.width_remark = '自定义';
      }
      if (sizeHeight2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0]) {
        currentData.height_remark = sizeHeight2(currentData.prop1, currentData.prop2, currentData.prop7.split('|')[0])[0];
      } else {
        currentData.height_remark = '自定义';
      }
      width_remark = '';
      height_remark = '';
    } else if (props === 'prop17') {
      let prop17 = currentData.prop17.split('|');
      prop17[0] = e.target.value;
      if (e.target.value === '手动') {
        prop17[1] = '无';
        prop17[2] = '';
      } else {
        prop17[3] = '否';
        prop17[2] = '右侧';
      }
      currentData.prop17 = prop17.join('|');
    }
    this.setState({
      currentData, width_remark, height_remark,
    });
  }
  changeInput = (type, e) => {
    if (type === 'height') {
      this.setState({
        height_remark: e.target.value
      })
    } else {
      this.setState({
        width_remark: e.target.value
      })
    }
  }
  onShow = (data, index,) => {
    // 'props'传入参数
    //index 在数组位置
    //data 值
    let currentData = data;
    let widthExplain = sizeWidth2(data.prop1, data.prop2, data.prop7.split('|')[0]);
    let heightExplain = sizeHeight2(data.prop1, data.prop2, data.prop7.split('|')[0]);
    let widthIndex = widthExplain.indexOf(data.width_remark);
    let heightIndex = heightExplain.indexOf(data.height_remark);
    let width_remark = '';
    let height_remark = '';
    if (widthIndex < 0) {
      width_remark = data.width_remark;
      data.width_remark = '自定义';
    }
    if (heightIndex < 0) {
      height_remark = data.height_remark;
      data.height_remark = '自定义';
    }

    this.setState({
      visible: true,
      currentData,
      index,
      width_remark, height_remark,
    });
  }
  onCancel = () => {
    this.setState({
      visible: false,
      width_remark: '',
      height_remark: '',
    });
  }
  onOk = () => {
    const { width_remark, height_remark, currentData, index, } = this.state;
    let updateData = { ...currentData };
    if (updateData.width_remark === '自定义') {
      updateData.width_remark = width_remark;
    }
    if (updateData.height_remark === '自定义') {
      updateData.height_remark = height_remark;
    }

    this.props.updateTable(updateData, index);
    this.onCancel()
  }
}
export default RelateModal;